import { render, staticRenderFns } from "./priceformat.vue?vue&type=template&id=67fec67e&"
import script from "./priceformat.vue?vue&type=script&lang=js&"
export * from "./priceformat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67fec67e')) {
      api.createRecord('67fec67e', component.options)
    } else {
      api.reload('67fec67e', component.options)
    }
    module.hot.accept("./priceformat.vue?vue&type=template&id=67fec67e&", function () {
      api.rerender('67fec67e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ybCELHLzYkal/JS/priceformat.vue"
export default component.exports